import forEach from 'lodash/forEach';
import get from 'lodash/get';
import toArray from 'lodash/toArray';

import { caseLogicMsg } from '../validationMessages';

function validateMigratedNodes(caseConf) {
  const errors = [];
  const warnings = [];

  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));

  // Checks
  const checkNodes = nodes.filter((node) => node.name === 'Check');
  checkNodes.forEach((node) => {
    forEach(node.data, (check) => {
      // Migration warning
      if (check.fromInfusionMigration) {
        warnings.push(
          caseLogicMsg('Check adjusted, please verify that it is functioning as intended', node.id, {
            migrationWarning: {
              details: 'Check adjusted, please verify that it is functioning as intended',
              link: 'https://vimeo.com/853393518/f72c070c0a'
            }
          })
        );
      }
    });
  });

  // Timers
  const timerNodes = nodes.filter(node => node.name === 'Timer');
  for (const timerNode of timerNodes) {
    if (timerNode.data.fromInfusionMigration) {
      warnings.push(
        caseLogicMsg('This timer was added to preserve functionality', timerNode.id, {
          migrationWarning: {
            details: 'This timer was added to preserve functionality',
            link: 'https://vimeo.com/853393518/f72c070c0a'
          }
        })
      );
    }
  }

  return {
    errors,
    warnings,
  };
}

export default validateMigratedNodes;
